import { useCallback } from "react";
import { NavigateOptions, useNavigate } from "react-router";

const useFixaNavigate = () => {
  const navigate = useNavigate();

  const fixaNavigate = useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === "string") {
        if (options) {
          navigate(to, options);
        } else {
          navigate(to);
        }
      } else {
        navigate(to);
      }
    },
    [navigate]
  );

  return fixaNavigate;
};

export default useFixaNavigate;
